var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTasks = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 250 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FDF2F8",
  fillRule: "evenodd",
  d: "M207 65a7 7 0 1 1 0 14h-40a7 7 0 1 1 0 14h22a7 7 0 1 1 0 14h-10.174c-4.874 0-8.826 3.134-8.826 7q0 3.866 6 7a7 7 0 1 1 0 14H93a7 7 0 1 1 0-14H54a7 7 0 1 1 0-14h40a7 7 0 1 0 0-14H69a7 7 0 1 1 0-14h40a7 7 0 1 1 0-14zm0 28a7 7 0 1 1 0 14 7 7 0 0 1 0-14",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m99.942 133.192 1.49-.051v20.999c0 .475.387.86.864.86h51.84a.86.86 0 0 0 .864-.86V82.155A3.16 3.16 0 0 0 151.832 79H104.6a3.16 3.16 0 0 0-3.168 3.155v14.968l-1.49-.052q-.262-.009-.526-.009c-9.035 0-16.416 8.062-16.416 18.07 0 10.007 7.38 18.07 16.416 18.07q.264 0 .526-.01m.165-6.902q-.345.028-.691.028c-5.453 0-9.773-5.055-9.773-11.186s4.32-11.186 9.773-11.186q.347 0 .691.027l1.325.106v22.105z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "m99.942 133.192 1.49-.051v20.999c0 .475.387.86.864.86h51.84a.86.86 0 0 0 .864-.86V82.155A3.16 3.16 0 0 0 151.832 79H104.6a3.16 3.16 0 0 0-3.168 3.155v14.968l-1.49-.052q-.262-.009-.526-.009c-9.035 0-16.416 8.062-16.416 18.07 0 10.007 7.38 18.07 16.416 18.07q.264 0 .526-.01Zm.165-6.902q-.345.028-.691.028c-5.453 0-9.773-5.055-9.773-11.186s4.32-11.186 9.773-11.186q.347 0 .691.027l1.325.106v22.105z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeOpacity: 0.2,
  strokeWidth: 3,
  d: "m99.942 133.192 1.49-.051v20.999c0 .475.387.86.864.86h51.84a.86.86 0 0 0 .864-.86V82.155A3.16 3.16 0 0 0 151.832 79H104.6a3.16 3.16 0 0 0-3.168 3.155v14.968l-1.49-.052q-.262-.009-.526-.009c-9.035 0-16.416 8.062-16.416 18.07 0 10.007 7.38 18.07 16.416 18.07q.264 0 .526-.01Zm.165-6.902q-.345.028-.691.028c-5.453 0-9.773-5.055-9.773-11.186s4.32-11.186 9.773-11.186q.347 0 .691.027l1.325.106v22.105z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BE185D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M147 85.182V103.5m0 5.682v4.743z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M67.128 147H74m107.128 0H184m-23 0h15.428M80 147h17.454"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.2,
  strokeWidth: 3,
  d: "M67.128 147H74m107.128 0H184m-23 0h15.428M80 147h17.454"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BE185D",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M128 35q-4 6.32-4 11c0 5.556 4.654 8.044 4.654 14.063q0 4.582-4.654 9.1M116 46c-.872 5.513 3 6.532 3 11.475q0 3.763-3 7.525M134.795 43.474c-1.321 3.42-.579 5.503 0 6.73 1.238 2.622 3.205 4.886 3.205 7.554q0 4.648-3.205 8.947"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#FDF2F8",
  d: "M105 84a1 1 0 0 1 1-1h7v69h-7a1 1 0 0 1-1-1z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#960145",
  d: "m131.439 111-5.192.016-4.322 7.487 2.586 4.497z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.2,
  d: "m131.439 111-5.192.016-4.322 7.487 2.586 4.497z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#960145",
  d: "m137.95 111-5.193.016-4.322 7.487 2.586 4.497z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.2,
  d: "m137.95 111-5.193.016-4.322 7.487 2.586 4.497z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#960145",
  d: "M124.928 111H118l3.277 6.008z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.2,
  d: "M124.928 111H118l3.277 6.008z"
})));
export default SvgTasks;